export default __webpack_public_path__ + "static/media/download.b9d18554.svg";